import React from "react";
import useForm, { Form } from "../../../../hooks/useForm";
import Controls from "../../../../components/form/controls/Controls";
import { notContainsOnlySpaces } from "../../../../utils";
import { changeKey } from "../../../../apis/System/_re_fresh.api";
import { NotifyConfirm, Notify } from "../../../../components/notify/Notify";

/*===================================== GLOBAL =====================================*/
const initialValue = {
  oldKey: "",
  newKey: "",
};

/**
 * Validate Data Input
 * @param {*} values
 */
const validationInput = (fieldValues, temp) => {
  if ("oldKey" in fieldValues) {
    temp.oldKey = notContainsOnlySpaces(fieldValues.oldKey)
      ? ""
      : "This field is required.";
    temp.oldKey =
      fieldValues.oldKey.length > 5000
        ? "This field is required to be 5000 characters in length!"
        : "";
  }

  if ("newKey" in fieldValues) {
    temp.newKey = notContainsOnlySpaces(fieldValues.newKey)
      ? ""
      : "This field is required.";
    temp.newKey =
      fieldValues.newKey.length > 5000
        ? "This field is required to be 5000 characters in length!"
        : "";
  }

  return temp;
};
/*===================================== GLOBAL =====================================*/

function Re_freshForm(props) {
  const { setOpenPopupChangeKey } = props;

  // Variable vaidate form
  const validateForm = (fieldValues = values) => {
    let temp = validationInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (values) return Object.values(temp).every((x) => x === "");
  };

  const { values, errors, setErrors, handleInputChange } = useForm(
    initialValue,
    true,
    validateForm
  );

  /************************ HANDLE  ************************/
  const handleSubmit = (e) => {
    e.preventDefault();

    NotifyConfirm("warning", "Are you sure you want to change ?", (result) => {
      if (result.isConfirmed) {
        if (validateForm()) {
          changeKey(values, async (result) => {
            if (result.status) Notify("success", "Success !!!");
            else Notify("error", "Dữ liêu không hợp lệ !!!");
          });
          setOpenPopupChangeKey(false);
        }
      }
    });
  };

  /************************ RETURN UI ************************/
  return (
    <Form onSubmit={handleSubmit}>
      <Controls.Input
        name="oldKey"
        value={values.oldKey}
        label="Old Key Change"
        type="text"
        onChange={handleInputChange}
        error={errors.oldKey}
        multiline
      />
      <Controls.Input
        name="newKey"
        value={values.newKey}
        label="New Key Change"
        type="text"
        onChange={handleInputChange}
        error={errors.newKey}
        multiline
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
      />
    </Form>
  );
}

export default Re_freshForm;
